import ARSTimeLineIconLarge from './ARSTimeLineIconLarge';

export default ARSTimeLineIconLarge;
